import React, { useCallback } from "react";
import PropTypes from "prop-types";
import EntitiesSelector, { commonPropTypes } from "./entities-selector";
import { injectIntl } from "react-intl";

const query = `
  query SourceUses {
    sourceUses {
      items
      total
    }
  }
`;

const SourceUseSelect = ({ intl, multiple = false, id = "use", name = "use", isInsideForm, ...props }) => {
  const handleDataFromResponse = useCallback(data => data.sourceUses, []);
  const handleGetValue = useCallback(element => element, []);
  const handleGetLabel = useCallback(element => intl.formatMessage({ id: `source.use.in.${element}` }), [intl]);

  return (
    <EntitiesSelector
      isInsideForm={isInsideForm}
      id={id}
      name={name}
      queryString={query}
      onGetDataFromResponse={handleDataFromResponse}
      onGetValue={handleGetValue}
      onGetLabel={handleGetLabel}
      {...props}
    />
  );
};

SourceUseSelect.propTypes = {
  ...commonPropTypes,
  /**
   * Valor del selector
   */
  selectedElement: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  /**
   * Valor del selector
   */
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
};

export default injectIntl(SourceUseSelect);
